// extracted by mini-css-extract-plugin
export default {"box":"index_box_wP5Yy"};